'use client';

import React from 'react';

import { signIn, useSession } from 'next-auth/react';

import { Button } from '@/components/ui/button';

import { AccountNavSkeleton } from './account-nav-skeleton';
import { UserAccountNav } from './user-account-nav';

export type ClientUserAccountNavProps = {
  authLoadingType: 'skeleton' | 'button';
};

export function ClientUserAccountNav({
  authLoadingType
}: ClientUserAccountNavProps) {
  const session = useSession();

  if (session.status === 'loading') {
    if (authLoadingType === 'button') {
      return (
        <Button disabled variant="secondary" size="sm">
          Login
        </Button>
      );
    }

    return <AccountNavSkeleton />;
  }

  if (session.status === 'unauthenticated') {
    return (
      <Button onClick={() => signIn()} variant="secondary" size="sm">
        Login
      </Button>
    );
  }

  return (
    <UserAccountNav
      user={{
        name: session.data?.user.name,
        email: session.data?.user.email,
        image: session.data?.user.image
      }}
    />
  );
}
